








































































































import Vue from "vue";
import {
  required,
  integer,
  minValue,
  minLength,
  requiredIf
} from "vuelidate/lib/validators";

import PromotionItemSelector from "../components/PromotionItemSelector.vue";
import {
  PromotionCheckForm,
  PromotionItemStatus,
  PromotionItemForm
} from "../forms/PromotionCheckForm";
import { Shop } from "../../shop/models/Shop";
import { Channel } from "../../channel/models/Channel";
import {
  PromotionResult,
  PromotionItemResult
} from "../models/PromotionResult";

export default Vue.extend({
  components: {
    PromotionItemSelector
  },
  validations: {
    promotionCheckForm: {
      shop: { required },
      date: { required },
      selectedChannel: {
        required
      },
      selectedItems: {
        required,
        minLength: minLength(1),
        $each: {
          status: {
            sameAs: function(status: any) {
              return status === PromotionItemStatus.Success;
            }
          }
        }
      },
      totalPrice: {
        required,
        minValue: minValue(0)
      }
    }
  },
  data() {
    const shops: Shop[] = [];
    const channels: Channel[] = [];
    const isLoading = false;
    const promotions: PromotionResult[] = [];
    const promotionCheckForm: PromotionCheckForm = {
      date: new Date(Date.now()),
      selectedItems: [],
      totalPrice: 0
    };
    return {
      shops,
      channels,
      isLoading,
      promotions,
      promotionCheckForm
    };
  },
  computed: {
    shopOptions() {
      return (this as any).shops;
    },
    channelOptions() {
      return (this as any).channels;
    },
    promotionsList() {
      return (this as any).promotions.map((promotion: any) => {
        return {
          id: promotion.id,
          name: promotion.name,
          children: promotion.conditions.map((condition: any) => {
            return {
              id: condition.id,
              children: condition.itemGroups.map((itemGroup: any) => {
                return {
                  id: itemGroup.id,
                  children: itemGroup.items.map((item: any) => {
                    return {
                      id: item.id,
                      name: item.item.name + " จำนวน : " + item.quantity
                    };
                  })
                };
              })
            };
          })
        };
      });
    },
    shopError() {
      return (this as any).$v.promotionCheckForm.shop.$error
        ? "Shop is required"
        : "";
    },
    dateError() {
      return (this as any).$v.promotionCheckForm.date.$error
        ? "Date is required or invalid"
        : "";
    },
    channelError() {
      return (this as any).$v.promotionCheckForm.selectedChannel.$error
        ? "channel is required or invalid"
        : "";
    },
    priceError() {
      return (this as any).$v.promotionCheckForm.totalPrice.$error
        ? "price is required or invalid"
        : "";
    }
  },
  async created() {
    await Promise.all([this.getShops(), this.getChannels()]);
  },
  methods: {
    goToPromotionViewPage() {
      this.$router.push({ name: "PromotionViewPage" });
    },
    async getShops() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.getShops({
          perPage: 9999
        });
        this.shops = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async getChannels() {
      try {
        const { data } = await (this as any).$dep.channelUseCase.getChannels({
          perPage: 9999
        });
        this.channels = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async checkItemsSelected() {
      try {
        const Items = this.promotionCheckForm.selectedItems.filter(
          (selectedItem: PromotionItemForm) => {
            return selectedItem.status === PromotionItemStatus.Init;
          }
        );
        const checkItems = Items.map((e: PromotionItemForm) => {
          return this.checkItem(e.sku);
        });

        const foundItems = (await Promise.all(checkItems)).filter(e => e);

        const newItems = this.promotionCheckForm.selectedItems.map(
          (item: PromotionItemForm) => {
            if (item.status === PromotionItemStatus.Init) {
              const foundItem = foundItems.find(foundItem => {
                return foundItem.code === item.sku;
              });
              if (foundItem) {
                return {
                  ...item,
                  ...foundItem,
                  status: PromotionItemStatus.Success
                };
              } else {
                return {
                  ...item,
                  status: PromotionItemStatus.Fail
                };
              }
            }
            return item;
          }
        );
        const newSelectedItem = this.removeDuplicateItem(newItems);
        this.promotionCheckForm.selectedItems = newSelectedItem;
        this.sumTotalPrice(this.promotionCheckForm.selectedItems);
      } catch (error) {
        console.log(error);
      }
    },
    async checkItem(sku: string) {
      try {
        const { data } = await (this as any).$dep.itemUseCase.checkItem(
          this.promotionCheckForm.shop,
          sku
        );
        return data;
      } catch (error) {
        return null;
      }
    },
    sumTotalPrice(seletedItems: PromotionItemForm[]) {
      const totalPrice = seletedItems
        .map((seletedItem: PromotionItemForm) => {
          return seletedItem.quantity * seletedItem.price! || 0;
        })
        .reduce((accumulator, current) => {
          return accumulator + current;
        }, 0);
      this.promotionCheckForm.totalPrice = totalPrice;
    },
    removeDuplicateItem(items: PromotionItemForm[]): PromotionItemForm[] {
      const distincts: Record<string, PromotionItemForm> = {};
      items.forEach(item => {
        distincts[item["sku"].toString()] = item;
      });
      return Object.values(distincts);
    },
    async checkPromotion() {
      try {
        const {
          data
        } = await (this as any).$dep.promotionUseCase.testPromotion(
          this.promotionCheckForm
        );
        this.promotions = data;
      } catch (error) {
        console.log(error);
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      await this.checkPromotion();
    },
    clear() {
      this.$v.$reset();
      this.promotionCheckForm = {
        date: new Date(Date.now()),
        selectedItems: [],
        totalPrice: 0
      };
      this.promotions = [];
    },
    promotionItemText(item: PromotionItemResult, promotion: PromotionResult) {
      let finalAmount = item.quantity * promotion.applyAmount;
      if (promotion.orderItemLimit) {
        finalAmount = Math.min(finalAmount, promotion.orderItemLimit);
      }

      return `${item.item.code} ชื่อ ${item.item.name} จำนวน : ${finalAmount}`;
    }
  }
});
